/**
 * ITalentFeatStatus interface.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ITalentFeatStatus.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @interface
 */
export enum ITalentFeatStatus {
  UNAVAILABLE = 4,
  GRANTED = 3,
  AVAILABLE = 1
};